module.exports = __webpack_public_path__ + "img/avatar2.29e9b492.png";